import { createListenerMiddleware } from '@reduxjs/toolkit';
import { constant, createListenerEffect, PREFERENCE, readLocalStorage, selectApp } from '@socialive/common';
import { setDefaultPreferences } from '@socialive/preferences';

export const effect = createListenerEffect(
  'setDefaultPreferences<Listener>',
  async (action, { dispatch, getState, unsubscribe, trigger }) => {
    unsubscribe();

    const app = selectApp(getState());

    const current = readLocalStorage(app);

    await dispatch(
      setDefaultPreferences({
        [PREFERENCE.MIGRATION_DATE]: 0,
        ...current,
      })
    );
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  // This listener will fire immediately -- which lets us set some preferences during initial startup
  matcher: constant(true),
  effect,
});

export default middleware;
